<template>
  <div class="other-chat-bubble">
    <div class="other-chat-bubble__content">
      <GeneralMessageChatComingTextSource
        v-show="isVisibleSource"
        :is-source-playing
        :chat-contents="chatMessageCall.src.contents"
        :is-complete="chatMessageCall.src.isComplete"
        :is-pending-src
        :language-code-set="chatMessageCall.srcLanguageSet"
        :using-auto-height="usingAutoHeight"
        :is-dm-message
      />
      <div v-show="isVisibleSource && isVisibleTarget" class="divider"></div>
      <GeneralMessageChatComingTextTarget
        v-show="isVisibleTarget"
        :is-target-playing
        :chat-contents="chatMessageCall.tgt.contents"
        :is-complete="chatMessageCall.tgt.isComplete"
        :is-interpreting="isInterpretingTgt"
        :language-code-set="chatMessageCall.tgtLanguageSet"
        :using-auto-height="usingAutoHeight"
        :is-dm-message
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

import GeneralMessageChatComingTextSource from '@/components/domains/chat/chat-general/GeneralMessageChatComingTextSource.vue';
import GeneralMessageChatComingTextTarget from '@/components/domains/chat/chat-general/GeneralMessageChatComingTextTarget.vue';
import { ChatMessage } from '@/types/socket';

const props = withDefaults(
  defineProps<{
    chatMessageCall: ChatMessage;
    isTargetPlaying: boolean;
    isSourcePlaying: boolean;
    isVisibleSource: boolean;
    isVisibleTarget: boolean;
    usingAutoHeight?: boolean;
    isDmMessage: boolean;
  }>(),
  {
    chatContents: () => [],
    isSourcePlaying: false,
    isTargetPlaying: false,
    isVisibleSource: false,
    isVisibleTarget: false,
    usingAutoHeight: true,
    isDmMessage: false,
  }
);

const isPendingSrc = computed(() => {
  return (
    props.chatMessageCall.reset === '0' && !props.chatMessageCall.src.contents
  );
});

const isInterpretingTgt = computed(() => {
  return (
    props.chatMessageCall.reset === '0' && !props.chatMessageCall.tgt.contents
  );
});
</script>

<style scoped lang="scss">
.other-chat-bubble {
  justify-content: flex-end;
  padding: 0.75rem 1rem;
  border-radius: 2px 12px 12px 12px;
  background: var(--surface-gray-dim);
  width: calc(100% - 4rem);
  margin-right: 0.5rem;
  flex-shrink: 0;
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;

  @include respond-from(tablet) {
    min-width: 70%;
    max-width: 70%;
  }
}

.other-chat-bubble__content {
  display: inline-flex;
  flex-direction: column;
  width: 100%;
}

.divider {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
</style>
